export const FINISHED_PACKING_REQUEST = "FINSIHED_PACKING_REQUEST";
export const FINISHED_PACKING_SUCCESS = "FINISHED_PACKING_SUCCESS";
export const FINISHED_PACKING_FAILED = "FINISHED_PACKING_FAILED";